var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$root.loader ? 'page-loader' : 'd-none'},[_c('div',{staticClass:"spinner-grow m-auto text-secondary"})])
}
var staticRenderFns = []

export { render, staticRenderFns }